import CASL from '@/utils/constants/casl'

export default {
  path: 'byd-approval',
  children: [
    {
      path: '',
      name: 'byd-approval.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.BYD_APPROVAL
      },
      component: () => import('./list/BydApprovalListPage.vue')
    }
  ]
}
